/**
 * AM addition: PDP sticky buy bar (main-product.liquid + custom.css).
 * - Tap sticky bar background → scroll to full buy-buttons position
 * - Preselect first available Color on mobile
 * - "Select Size" scrolls to size options; products without sizes use normal cart state
 * - "Select Size" / "Sold out" labels on .js-add-to-cart
 */
(function () {
  function initBuyButtonsInlineState(section, buyButtons) {
    if (window.innerWidth >= 900) return;
    if (buyButtons.dataset.amBuyButtonsInlineBound === 'true') return;
    buyButtons.dataset.amBuyButtonsInlineBound = 'true';

    var infoContainer = section.querySelector('.product__info-container');
    if (!infoContainer) return;

    var sentinel = buyButtons.nextElementSibling;
    if (!sentinel || !sentinel.classList.contains('am-buy-buttons-sentinel')) {
      sentinel = document.createElement('div');
      sentinel.className = 'am-buy-buttons-sentinel';
      sentinel.setAttribute('aria-hidden', 'true');
      buyButtons.insertAdjacentElement('afterend', sentinel);
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          buyButtons.classList.toggle('am-buy-buttons--inline', entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );

    observer.observe(sentinel);
    buyButtons._amBuyButtonsInlineObserver = observer;
  }

  function initMobilePDP(section) {
    var buyButtons = section.querySelector('.main-product__buy-buttons--container');
    if (!buyButtons) return;

    initBuyButtonsInlineState(section, buyButtons);

    if (buyButtons.dataset.amBuyButtonsClickBound === 'true') return;
    buyButtons.dataset.amBuyButtonsClickBound = 'true';

    function selectSize(e) {
      if (e.type === 'click' && !e.target.closest('.js-add-to-cart')) return;
      if (e.type === 'submit' && !e.target.querySelector('.js-add-to-cart')) return;

      var sizeInputs = section.querySelectorAll('input[type="radio"][name="Size"]');
      if (!sizeInputs.length || Array.prototype.some.call(sizeInputs, function (input) {
        return input.checked;
      })) return;

      // This CTA navigates until a size is chosen; never submit a fallback variant.
      e.preventDefault();
      e.stopImmediatePropagation();
      var picker = sizeInputs[0].closest('fieldset') || sizeInputs[0].parentElement;
      picker.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
        block: 'center'
      });
      var firstAvailable = Array.prototype.find.call(sizeInputs, function (input) {
        return !input.disabled;
      });
      if (firstAvailable) firstAvailable.focus({ preventScroll: true });
    }

    buyButtons.addEventListener('click', selectSize, true);
    buyButtons.addEventListener('submit', selectSize, true);

    buyButtons.addEventListener('click', function (e) {
      // Don't intercept actual button clicks
      if (e.target.closest('button, a, input, select')) return;

      // Scroll to where the buy buttons naturally sit at the bottom of info
      var infoContainer = section.querySelector('.product__info-container');
      if (!infoContainer) return;

      var targetY =
        infoContainer.getBoundingClientRect().bottom +
        window.scrollY -
        window.innerHeight +
        buyButtons.offsetHeight;

      (function smoothScrollTo(target, duration) {
        var start = window.scrollY;
        var distance = target - start;
        var startTime = null;

        document.documentElement.style.scrollBehavior = 'auto';

        function ease(t) {
          return t;
        }

        function step(timestamp) {
          if (!startTime) startTime = timestamp;
          var progress = Math.min((timestamp - startTime) / duration, 1);
          window.scrollTo(0, start + distance * ease(progress));
          if (progress < 1) {
            requestAnimationFrame(step);
          } else {
            document.documentElement.style.scrollBehavior = '';
          }
        }

        requestAnimationFrame(step);
      })(targetY, 500);
    });
  }

  function preselectColor(section) {
    // Only run on mobile
    if (window.innerWidth >= 900) return;

    var colorInputs = section.querySelectorAll(
      'input[type="radio"][name="Color"]'
    );
    if (!colorInputs.length) return;

    // Find first available (not disabled) color input
    var firstAvailable = null;
    colorInputs.forEach(function (input) {
      if (!firstAvailable && !input.disabled && !input.classList.contains('disabled')) {
        firstAvailable = input;
      }
    });

    if (!firstAvailable) return;

    // Select it and fire change event so theme variant logic updates
    firstAvailable.checked = true;
    firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function updateLabelForSection(section) {
    if (window.innerWidth >= 900) return;

    var submitButton = section.querySelector('.js-add-to-cart');
    if (!submitButton) return;

    var variantOptions = section.querySelector('variant-options[data-in-store-only="true"]');
    var isInStoreOnly = Boolean(variantOptions);

    var sizeInputs = section.querySelectorAll('input[type="radio"][name="Size"]');
    var colorInputs = section.querySelectorAll('input[type="radio"][name="Color"]');

    var sizeSelected = false;
    var selectedSizeInput = null;
    sizeInputs.forEach(function (input) {
      if (input.checked) {
        sizeSelected = true;
        selectedSizeInput = input;
      }
    });

    var colorSelected = false;
    colorInputs.forEach(function (input) {
      if (input.checked) colorSelected = true;
    });

    var span = submitButton.querySelector('span');
    if (!span) return;

    var needsColor = colorInputs.length > 0;
    var needsSize = sizeInputs.length > 0;
    var waitingOnOptions =
      (needsColor && !colorSelected) || (needsSize && !sizeSelected);

    if (isInStoreOnly && !waitingOnOptions) {
      var inStoreLabel =
        (window.variantStrings && window.variantStrings.inStoreOnly) ||
        'AVAILABLE IN-STORE ONLY';
      var wasInStore = submitButton.classList.contains('am-atc-in-store');
      if (span.textContent !== inStoreLabel) span.textContent = inStoreLabel;
      submitButton.classList.remove('am-atc-notify');
      submitButton.removeAttribute('data-am-notify');
      submitButton.classList.add('am-atc-in-store');
      submitButton.setAttribute('data-am-in-store-only', 'true');
      submitButton.setAttribute('aria-label', inStoreLabel);
      submitButton.disabled = false;
      if (!wasInStore) {
        submitButton.classList.remove('am-atc-filled');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            submitButton.classList.add('am-atc-filled');
          });
        });
      } else {
        submitButton.classList.add('am-atc-filled');
      }
      return;
    }

    if (needsSize && !sizeSelected) {
      var selectSizeLabel =
        (window.variantStrings && window.variantStrings.selectSize) || 'Select Size';
      if (span.textContent !== selectSizeLabel) span.textContent = selectSizeLabel;
      submitButton.classList.remove('am-atc-notify', 'am-atc-filled', 'am-atc-in-store');
      submitButton.removeAttribute('data-am-notify');
      submitButton.removeAttribute('data-am-in-store-only');
      submitButton.setAttribute('aria-label', selectSizeLabel);
      submitButton.disabled = false;
    } else if ((!needsColor || colorSelected) && sizeSelected) {
      var isSoldOut =
        selectedSizeInput &&
        (selectedSizeInput.disabled || selectedSizeInput.classList.contains('disabled'));
      if (isSoldOut) {
        var notifyLabel =
          (window.variantStrings && window.variantStrings.notifyWhenBack) ||
          'Notify me when back in stock';
        var wasNotify = submitButton.classList.contains('am-atc-notify');
        if (span.textContent !== notifyLabel) span.textContent = notifyLabel;
        submitButton.disabled = false;
        submitButton.classList.add('am-atc-notify');
        submitButton.setAttribute('data-am-notify', 'true');
        submitButton.setAttribute('aria-label', notifyLabel);
        if (!wasNotify) {
          submitButton.classList.remove('am-atc-filled');
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              submitButton.classList.add('am-atc-filled');
            });
          });
        } else {
          submitButton.classList.add('am-atc-filled');
        }
      }
    }
  }

  function bindButtonLabelListeners() {
    if (window.__amPdpMobileLabelBound) return;
    window.__amPdpMobileLabelBound = true;

    document.addEventListener('variantChangeEnd', function (e) {
      var section = e.target.closest('.wt-product__wrapper');
      if (section) updateLabelForSection(section);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var sectionId = event.data && event.data.sectionId;
        if (!sectionId) return;
        var section = document.querySelector(
          '.wt-product__wrapper[data-section-id="' + sectionId + '"]'
        );
        if (section) updateLabelForSection(section);
      });
    }
  }

  function watchButtonLabel(section) {
    bindButtonLabelListeners();
    updateLabelForSection(section);
  }

  function init() {
    document.querySelectorAll('.wt-product__wrapper').forEach(function (section) {
      initMobilePDP(section);
      preselectColor(section);
      watchButtonLabel(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initMobilePDP(e.target);
    preselectColor(e.target);
    watchButtonLabel(e.target);
  });
})();
